import React from "react";

const Container = (props) => {
  return <div className="px-4 pb-4 pt-[130px]">{props?.children}</div>;
};

export default Container;
